function copyURL() {
    const button = document.getElementById("copy-url-btn");
    const feedback = document.getElementById("feedback");

    button.addEventListener("click", async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            feedback.textContent = "URL copied to clipboard!";
            feedback.classList.add("show");
            button.classList.add("copied");

            // Remove feedback and button copied state after 2 seconds
            setTimeout(() => {
                feedback.classList.remove("show");
                button.classList.remove("copied");
            }, 2000);
        } catch (err) {
            console.error("Failed to copy:", err);
            feedback.textContent = "Failed to copy URL.";
            feedback.classList.add("show");

            setTimeout(() => {
                feedback.classList.remove("show");
            }, 2000);
        }
    });
}
document.addEventListener("DOMContentLoaded", function () {
    if (document.body.classList.contains('single-post') === true) {
        copyURL();
    }
});
